export class Constants {

  public static ENCRYPTION_SECRET_KEY = "nlFi2Xg2t4S2gk6i";
  public static CV_ENCRYPTION_SECRET_KEY = "hey@123451234545";

  public static OTHER_ACCESSORIES_VALUE_PERCENTAGE_OF_IDV = 0.10;
  public static REGISTRATION_NO_REGEX = /^[a-zA-Z]{2}[0-9]{1}[a-zA-z0-9]{0,3}[a-zA-Z]{0,1}[0-9]{4}$/;
  public static DIGITS_ONLY_REGEX = /^[0-9]*$/;
  public static PINCODE_REGEX = /[0-9]{6}/;
  public static AADHAR_REGEX = /[0-9]{12}/;
  public static ALPHANUMERIC_REGEX = /^[0-9a-z]+$/i;
  public static GSTIN_NO_REGEX = /^[0-9]{2}[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}Z[0-9a-zA-Z]{1}$/;
  // tslint:disable-next-line: max-line-length
  public static EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  public static MOBILE_NUMBER_REGEX = /^[6789]{1}[0-9]{9}$/;
  public static NAME_ALPHABETS_REGEX = /[a-zA-Z ]{1,23}/;
  public static NAME_WITH_DOT_ALPHABETS_REGEX = /[a-zA-Z. ]{1,23}/;
  public static NAME_REGEX_WITH_SPACE = /^[a-zA-Z ]*$/;
  public static NAME_WITH_MIN_TWO_WORDS_REGEX = /((\b[a-zA-Z]{2,40}\b)\s*){2,}$/;

  public static DIRECITVE_NAME_ALPHABETS_REGEX = /[^a-zA-Z ]*/g;
  public static DIRECTIVE_NAME_WITH_DOT_ALPHABETS_REGEX = /[^a-zA-Z. ]*/g;
  public static HTTP_STATUS_OK = 200;


  public static API_URL_GLOBAL_DATACREATION_DOCUMENTS = '/data-creation/documents';
  public static API_URL_GLOBAL_PETITION_DOCUMENT_DOCUMENTS = '/petition-document/documents';
  public static API_URL_GLOBAL_HOSPITAL_EMPANELMENT_DOCUMENTS = '/hospital-empanelment/documents';
  public static URL_ENCRYPTION_LEVEL = 2;
  public static API_URL_PAYMENT_SUBMIT = '/payment/submit';

   public static API_URL_CHECK_CANDIDATE_EXISTS = '/itgi-hiring/candidateForm/check-candidate-exists';
   public static API_URL_SAVE_CANDIDATE_DETAILS = '/itgi-hiring/candidateForm/save-candidate-details';

   public static API_URL_GET_DOCUMENT = '/itgi-hiring/candidateForm/get-vacancy-document/'
 

  public static API_URL_SAVE_NEW_JOINEE_DETAILS = '/itgi-hiring/joinee/saveJoineeDetails';
  public static API_URL_GET_REQUESTS = '/itgi-hiring/joinee/requests';
  public static API_URL_SAVE_CANDIDATE_DOCUMENTS = '/save-documents';
  public static API_URL_GET_NEW_JOINEE_DETAILS = '/itgi-hiring/joinee/getJoineeDetails/';
  public static API_URL_GET_NEW_JOINEE_DETAILS_BY_NAME = '/itgi-hiring/joinee/getJoineeDetailsByName/';
  public static API_URL_GET_NEW_JOINEE_DETAILS_BY_NAME_DATE = '/itgi-hiring/joinee/getJoineeDetailsByNameAndDate/';
  public static API_URL_GET_NEW_JOINEE_DETAILS_BY_MOBILE = '/itgi-hiring/joinee/getJoineeDetailsByMobile/';
  public static API_URL_GET_NEW_JOINEE_DETAILS_BY_MOBILE_DATE = '/itgi-hiring/joinee/getJoineeDetailsByMobileAndDate/';
  public static API_URL_GET_NEW_JOINEE_DETAILS_BY_FUNCTION = '/itgi-hiring/joinee/getJoineeDetailsByFunction/';
  public static API_URL_GET_NEW_JOINEE_DETAILS_BY_FUNCTION_DATE = '/itgi-hiring/joinee/getJoineeDetailsByFunctionAndDate/';
  public static API_URL_GET_NEW_JOINEE_DETAILS_BY_DATE = '/itgi-hiring/joinee/getJoineeDetailsByDate/';
  public static API_URL_GET_DOCUMENT_DETAILS = '/itgi-hiring/joinee/getDocumentDetailById/';
  public static API_URL_GET_MASTER_DATA = '/itgi-hiring/master/getData';

  public static API_URL_GET_AGE_MASTER = '/itgi-hiring/common/getAgeMaster';
  public static API_URL_GET_INSURANCE_QUALIFICATION_MASTER = '/itgi-hiring/common/getInsuranceQualificationMaster';
  public static API_URL_GET_HIGHEST_EDUCATION_MASTER = '/itgi-hiring/common/getHighestEducationMaster';
  public static API_URL_GET_FUNCTION_MASTER = '/itgi-hiring/common/getFunctionMaster';
  public static API_URL_GET_EXPERIENCE_MASTER = '/itgi-hiring/common/getExperienceMaster';
  public static API_URL_GET_NOTICE_PERIOD_MASTER = '/itgi-hiring/common/getNoticePeriodMaster';
  public static API_URL_GET_CURRENT_CTC_MASTER = '/itgi-hiring/common/getCTCMaster';
  public static API_URL_GET_STATE_MASTER = '/itgi-hiring/common/getStateMaster';
  public static  API_URL_GET_LOCATION_MASTER= '/itgi-hiring/common/getLocationMaster';

  public static API_URL_LOGIN = '/itgi-hiring/login/login';
  

}
